<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="modosDePagamento.content"
      class="elevation-1 mt-5 pt-3 rounded-card"
      :loading="loading"
      :server-items-length="modosDePagamento.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum modo de pagamento encontrada"
      loading-text="Carregando modos de pagamento..."
      :options="optionsList"
    >
      <template v-slot:item.codigoInterno="{ item }">
        {{ item.codigoInterno | naoInformado }}
      </template>
      <template v-slot:item.options="{ item }" v-if="hasModuleGerencia">
        <v-btn icon
               @click="goToEditFormaDePagamento(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon
               @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    modosDePagamento: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          value: 'codigoInterno',
        },
        {
          text: 'Forma de pagamento',
          value: 'descricao',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditFormaDePagamento(item) {
      this.$router.push({
        name: 'main.modos-pagamento.edicao',
        params: {
          id: item.id,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover esta forma de pagamento?',
        'A forma de pagamento será removido e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
  },
};
</script>
